import React from 'react';

import cameraIcon from 'assets/sidebar-camera.svg';

const SidebarCameraIcon = ({
  onClick,
  className,
}: {
  onClick: () => void;
  className?: string;
}): JSX.Element => (
  <img
    src={cameraIcon}
    alt="camera-icon"
    className={`camera-icon ${className}`}
    onClick={() => onClick()}
  />
);

export default SidebarCameraIcon;
